__turbopack_context__.v({
  "className": "host_grotesk_4b491449-module__YkXKKG__className",
});
